<template>
  <div class="container">
    <div class="containe">
      <img src="../assets/images/logo2.png" class="logo" alt="" />
      <div class="con-right">
        <div class="list" @mouseleave="moveOut()">
          <ul>
            <li
              :class="[navIndex == '/home' ? 'li-active' : '']"
              @click="toPage('/home')"
              @mouseover="moveIn('/home')"
              style="padding: 26px 42px 20px 28px"
            >
              首页
            </li>
            <!-- <li :class="[navIndex=='/solution'?'li-active1 sche':'sche']" @click="toPage('/solution')" @mouseover="moveIn('/solution')" @mouseleave="moveOutSolution" style="padding:26px 15px 20px 27px;position:relative">解决方案<span></span>
        </li> -->
            <li
              :class="[navIndex == '/show' ? 'li-active1 sche' : 'sche']"
              @mouseover="moveIn('/show')"
              style="padding:26px 15px 20px 27px;position:relative"
            >
              产品展示<span></span>
              <div v-show="showPro" class="sele " @mouseleave="outSolution">
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 1 ? 'index-active' : '']"
                  value="1"
                  @click="toSolution(1)"
                  style="height:60px"
                  >住房城乡建设</option
                >
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 2 ? 'index-active' : '']"
                  value="2"
                  @click="toSolution(2)"
                  >交通运输</option
                >
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 3 ? 'index-active' : '']"
                  value="3"
                  @click="toSolution(3)"
                  >食品安全</option
                >
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 4 ? 'index-active' : '']"
                  value="4"
                  @click="toSolution(4)"
                  >医疗卫生</option
                >
                <!-- <option class="animate__animated animate__headShake" :class="[solutionIndex==6?'index-active':'']" value="6" @click="toSolution(6)">环境保护</option> -->
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 7 ? 'index-active' : '']"
                  value="7"
                  @click="toSolution(7)"
                  >安全生产</option
                >
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 8 ? 'index-active' : '']"
                  value="8"
                  @click="toSolution(8)"
                  >纪检监察</option
                >
                <option
                  class="animate__animated animate__headShake"
                  :class="[solutionIndex == 9 ? 'index-active' : '']"
                  value="9"
                  @click="toSolution(9)"
                  >其他</option
                >
              </div>
            </li>
            <!-- <li :class="[navIndex=='/example'?'li-active1':'']" @click="toPage('/example')" @mouseover="moveIn('/example')" >客户案例</li> -->
            <!-- <li :class="[navIndex=='/newscenter'?'li-active1':'']" @click="toPage('/newscenter')" @mouseover="moveIn('/newscenter')">新闻中心</li> -->
            <!-- <li :class="[navIndex=='/course'?'li-active1':'']" @click="toPage('/course')" @mouseover="moveIn('/course')" >课程介绍</li> -->
            <li
              :class="[navIndex == '/about' ? 'li-active1' : '']"
              @click="toPage('/about')"
              @mouseover="moveIn('/about')"
            >
              关于我们
            </li>
          </ul>
        </div>
        <div class="phone">
          <img src="../assets/images/phone.png" alt="" />
          <p>400-9999-355</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navIndex: "/home",
      solution: false,
      example: false,
      solutionIndex: "",
      showPro: false
    };
  },
  mounted() {
    // console.log(this.$route, '333')
    if (this.$route.path == "/") {
      this.navIndex = "/home";
    } else {
      if (
        this.$route.path == "/introduceihec" ||
        this.$route.path == "/proproducts" ||
        this.$route.path == "/companypro"
      ) {
        this.navIndex = "/show";
      } else if (this.$route.path == "/insdustrysolution") {
        this.navIndex = "/solution";
      } else {
        this.navIndex = this.$route.path;
      }
    }
  },
  methods: {
    fun() {
      let str = "123";
      // console.log(str)
    },
    toPage(value) {
      this.navIndex = value;
      this.solution = false;
      this.example = false;
      if (value == "/solution") {
        this.solution = true;
      } else if (value == "/show") {
        this.$router.push("/proproducts");
      } else if (value == "/home") {
        this.$router.push({
          path: "/home"
        });
        window.localStorage.removeItem("page");
      } else {
        this.$router.push(value);
      }
    },
    moveIn(value) {
      this.navIndex = value;
      this.solution = false;
      this.example = false;
      if (value == "/show") {
        this.example = true;
        this.showPro = true;
      } else {
        this.showPro = false;
      }
    },
    moveOut() {
      if (this.$route.path == "/") {
        this.navIndex = "/home";
      } else {
        if (
          this.$route.path == "/introduceihec" ||
          this.$route.path == "/proproducts" ||
          this.$route.path == "/companypro"
        ) {
          this.navIndex = "/show";
        } else if (
          this.$route.path == "/insdustrysolution" ||
          this.$route.path == "/solution"
        ) {
          this.navIndex = "/solution";
        } else {
          this.navIndex = this.$route.path;
        }
      }
      this.showPro = false;
    },
    moveOutSolution() {
      this.showPro = false;
    },
    fmoveIn() {
      this.navIndex = "/solution";
    },
    fmoveOut() {
      // console.log(this.$route.path, 'pathpath')
      if (this.$route.path == "/") {
        this.navIndex = "/home";
      } else {
        if (
          this.$route.path == "/introduceihec" ||
          this.$route.path == "/proproducts" ||
          this.$route.path == "/companypro"
        ) {
          this.navIndex = "/show";
        } else {
          this.navIndex = this.$route.path;
        }
      }
      this.solution = false;
      this.example = false;
    },
    toSolution(num) {
      this.$router.push(
        "/proproducts?type=" + num + "&_t=" + new Date().getTime()
      );
      // this.$router.push({
      //   path: '/proproducts',
      //   query: {
      //     typeid: num
      //   }
      // })
    },
    soluMoveIn(idx) {
      // console.log(idx, 'index')
      this.solutionIndex = idx;
    },
    outSolution() {
      // console.log('33')
      console.log(this.$route.path, "this.$route.path");
      if (
        this.$route.path == "/insdustrysolution" ||
        this.$route.path == "/solution"
      ) {
        // console.log('true')
        this.navIndex = "/solution";
      }
    }
  }
};
</script>

<style scoped>
.containe {
  position: absolute;
  top: 30px;
  width: 100%;
  height: 70px;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
  /* position: relative; */
}
.logo {
  width: 230px;
  margin-left: 7.7%;
}
.con-right {
  display: flex;
  width: 840px;
  justify-content: space-between;
}
.list {
  /* width: 50%; */
}
.list ul li {
  list-style: none;
  cursor: pointer;
  float: left;
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  border-right: 1px solid;
  padding: 26px 27px 20px 27px;
  /* margin-right: 3px; */
  border-image: -webkit-linear-gradient(
      -180deg,
      rgba(255, 255, 255, 0) 20%,
      #d4d4d4 50%,
      rgba(255, 255, 255, 0) 80%
    )
    2 2 2 2;
  border-image: -moz-linear-gradient(
      -180deg,
      rgba(255, 255, 255, 0) 20%,
      #d4d4d4 50%,
      rgba(255, 255, 255, 0) 80%
    )
    2 2 2 2;
  border-image: linear-gradient(
      -180deg,
      rgba(255, 255, 255, 0) 20%,
      #d4d4d4 50%,
      rgba(255, 255, 255, 0) 80%
    )
    2 2 2 2;
}
.li-active {
  background-image: url("../assets/images/home-active.png");
  background-position: -7px 0px;
  background-size: 112px 71px;
  background-repeat: no-repeat;
  color: #fff !important;
}
.li-active1 {
  background-image: url("../assets/images/home-active.png");
  background-position: 10px 0px;
  background-size: 112px 71px;
  background-repeat: no-repeat;
  color: #fff !important;
}
.list ul li:first-child {
  border-right: none;
  margin-right: 15px;
}
.list ul li:last-child {
  border-right: none;
}
.list ul .sche span {
  display: inline-block;
  width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
  height: 0px;
  border: 5px solid #727272;
  border-bottom-color: transparent; /* 设置透明背景色 */
  border-left-color: transparent;
  border-right-color: transparent;
  vertical-align: -1px;
  margin-left: 2px;
}
.phone {
  display: flex;
  justify-content: space-around;
  padding-right: 4.7%;
}
.phone img {
  width: 40px;
  height: 40px;
  align-self: center;
}
.phone p {
  width: 160px;
  margin-top: 3px;
  margin-left: 9px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #fff;
  align-self: center;
}
.list ul li .sele {
  position: absolute;
  top: 70px;
  left: -28px;
  border-radius: 5px;
  color: #000;
}
.list ul li .sele option {
  width: 180px;
  height: 60px;
  background-color: #fff;
  line-height: 60px;
  text-align: center;
  transition: all 0.5s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.list ul li .sele option:hover {
  background-color: #ccc;
}
.list-index {
  width: 100%;
  height: 40px;
  z-index: 99999;
  position: absolute;
  top: 100px;
}
.list-index div {
  width: 33.33%;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.list-index .index-active {
  /* background-color: #B00000; */
  background-color: rgba(176, 0, 0, 0.5);
  transition: all 0.5s ease;
  cursor: pointer;
}
.list-index div p {
  color: #fff;
  opacity: 1 !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 40px;
}
.list-index .index-active {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/topNav.vue